module.exports = __webpack_public_path__ + "static/media/top-view-rest.2f8d09b4.png";